import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
   // tslint:disable-next-line:directive-selector
   selector: 'am-view-check-button'
})
export class ViewCheckButtonUpgradedDirective extends UpgradeComponent {
   @Input() check: any;

   constructor(elementRef: ElementRef, injector: Injector) {
      super('amViewCheckButton', elementRef, injector);
   }
}
